import { createAction, props } from '@ngrx/store';

/** A "do nothing" action that will get fired if the user tries to navigate to an invalid data product. */
export const attemptedInvalidDataProduct = createAction(
  '[Data Product] Attempted Invalid Data Product',
  props<{ catalogId: string | undefined; dataProductId: string | undefined }>()
);
export const loadDataProduct = createAction(
  '[Data Product] Load Data Product',
  props<{ catalogId: string | undefined; dataProductId: string | undefined }>()
);
export const loadSupportedOperations = createAction('[Data Product] Load Supported Operations');
export const loadVariableCount = createAction('[Data Product] Load Variable Count');
